import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ name, links = [], subViews = [] }) {
    this.name = name;
    this.links = links;
    this.subViews = subViews;
  },

  beforeRender() {
    this.subViews.forEach((subView, idx) => {
      const id = this.computeSubViewID(idx);
      this.addSubview(id, `#${id}`, subView);
    });
  },

  context() {
    return {
      name: this.name,
      links: this.links,
      subViews: this.subViews,
      computeSubViewID: this.computeSubViewID.bind(this),
    };
  },

  computeSubViewID(idx) {
    return `header-subview-${idx}`;
  },
});



// WEBPACK FOOTER //
// ./app/components/page_header/index.js